"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBarAppSwitcher = void 0;
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const icons_material_1 = require("@mui/icons-material");
function SideBarAppSwitcher(props) {
    return (react_1.default.createElement(material_1.Accordion, { defaultExpanded: true, disableGutters: true, sx: {
            backgroundColor: 'inherit',
            boxShadow: 'none',
        } },
        react_1.default.createElement(material_1.AccordionSummary, { sx: { padding: '0px' }, expandIcon: react_1.default.createElement(icons_material_1.ExpandMore, { sx: { color: 'white' } }) },
            react_1.default.createElement(material_1.Typography, { variant: "body1", sx: {
                    color: '#FFFFFF',
                    fontFeatureSettings: "'liga' off, 'clig' off",
                    fontFamily: 'Effra',
                    fontSize: '1rem',
                    fontWeight: 400,
                    lineHeight: '1.5rem',
                    letterSpacing: '0.00938rem',
                } }, "Apps")),
        react_1.default.createElement(material_1.AccordionDetails, { sx: { padding: '0px' } },
            react_1.default.createElement("div", { className: "grid grid-cols-2 gap-[1rem]" }, props.children))));
}
exports.SideBarAppSwitcher = SideBarAppSwitcher;
